export default "__VITE_ASSET__Da04Z5GZ__"